module.exports = __webpack_public_path__ + "39d93cf.woff2";